import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { UserApiService } from 'features/users';
import { User } from 'types';

import { userQueryKeys } from './query-keys';

const { getMenuItem } = UserApiService();

const getUserQuery = (
  id: string,
  options?: UseQueryOptions<User>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<User>;
  options?: UseQueryOptions<User>;
} => ({
  queryKey: userQueryKeys.detail(id),
  queryFn: ({ signal }) => getMenuItem(id, { config: { signal } }),
  ...options,
});

export const useGetMenu = (id: string, options?: UseQueryOptions<any>) => {
  const { message } = App.useApp();

  return useQuery<any, Error>(
    getUserQuery(id, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
